// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingPropertyWebApiHandler_getApplicantsForProperty,
  LeasingPropertyWebApiHandler_getApplicantsForProperty_Path,
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty,
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path,
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty,
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path,
  LeasingPropertyWebApiHandler_getPropertyInfo,
  LeasingPropertyWebApiHandler_getPropertyInfo_Path,
  LeasingPropertyWebApiHandler_getWebAnalytics,
  LeasingPropertyWebApiHandler_getWebAnalytics_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetApplicantsForPropertyWebApiResponseDto,
  GetLeaseSupportForPropertyWebApiResponseDto,
  GetPropertyInfoResponseDto,
  LeasingGetLeasesPaginatedResponseDto,
  ListingAlias,
  WebAnalyticsWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetApplicantsForPropertyParams {
  propertyId: string;
}
interface GetLeaseSupportForPropertyParams {
  propertyId: string;
}
interface GetPaginatedLeasesForLandlordPropertyParams {
  listingAlias: ListingAlias;
  numResults: number;
  offset: number;
}
interface GetPropertyInfoParams {
  propertyId: string;
}
interface GetWebAnalyticsParams {
  listingAlias: ListingAlias;
}

export type LeasingPropertyWebApiHandler_getApplicantsForProperty_Options = UseQueryOptions<
  GetApplicantsForPropertyWebApiResponseDto,
  unknown,
  GetApplicantsForPropertyWebApiResponseDto,
  readonly [string, GetApplicantsForPropertyParams]
>;

const LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey = (getParams: GetApplicantsForPropertyParams) =>
  [LeasingPropertyWebApiHandler_getApplicantsForProperty_Path, getParams] as const;

export const LeasingPropertyWebApiHandler_getApplicantsForProperty_queryOptions = (
  getParams: GetApplicantsForPropertyParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getApplicantsForProperty(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get property applicants
 */
export const useLeasingPropertyWebApiHandler_getApplicantsForProperty = (
  getParams: GetApplicantsForPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getApplicantsForProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingPropertyWebApiHandler_getApplicantsForProperty_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyWebApiHandler_getApplicantsForProperty.getKey =
  LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey;

export type LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Options = UseQueryOptions<
  GetLeaseSupportForPropertyWebApiResponseDto,
  unknown,
  GetLeaseSupportForPropertyWebApiResponseDto,
  readonly [string, GetLeaseSupportForPropertyParams]
>;

const LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey = (getParams: GetLeaseSupportForPropertyParams) =>
  [LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path, getParams] as const;

export const LeasingPropertyWebApiHandler_getLeaseSupportForProperty_queryOptions = (
  getParams: GetLeaseSupportForPropertyParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getLeaseSupportForProperty(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get the geography name and explainer lease for a property
 */
export const useLeasingPropertyWebApiHandler_getLeaseSupportForProperty = (
  getParams: GetLeaseSupportForPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingPropertyWebApiHandler_getLeaseSupportForProperty_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyWebApiHandler_getLeaseSupportForProperty.getKey =
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey;

export type LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Options = UseQueryOptions<
  LeasingGetLeasesPaginatedResponseDto,
  unknown,
  LeasingGetLeasesPaginatedResponseDto,
  readonly [string, GetPaginatedLeasesForLandlordPropertyParams]
>;

const LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
) => [LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path, getParams] as const;

export const LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_queryOptions = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get all leases for property with message and signing by listing alias
 */
export const useLeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty.getKey =
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey;

export type LeasingPropertyWebApiHandler_getPropertyInfo_Options = UseQueryOptions<
  GetPropertyInfoResponseDto,
  unknown,
  GetPropertyInfoResponseDto,
  readonly [string, GetPropertyInfoParams]
>;

const LeasingPropertyWebApiHandler_getPropertyInfo_GetKey = (getParams: GetPropertyInfoParams) =>
  [LeasingPropertyWebApiHandler_getPropertyInfo_Path, getParams] as const;

export const LeasingPropertyWebApiHandler_getPropertyInfo_queryOptions = (
  getParams: GetPropertyInfoParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyWebApiHandler_getPropertyInfo_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getPropertyInfo(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get property data for listing
 */
export const useLeasingPropertyWebApiHandler_getPropertyInfo = (
  getParams: GetPropertyInfoParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getPropertyInfo_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingPropertyWebApiHandler_getPropertyInfo_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyWebApiHandler_getPropertyInfo.getKey = LeasingPropertyWebApiHandler_getPropertyInfo_GetKey;

export type LeasingPropertyWebApiHandler_getWebAnalytics_Options = UseQueryOptions<
  WebAnalyticsWebApiResponseDto,
  unknown,
  WebAnalyticsWebApiResponseDto,
  readonly [string, GetWebAnalyticsParams]
>;

const LeasingPropertyWebApiHandler_getWebAnalytics_GetKey = (getParams: GetWebAnalyticsParams) =>
  [LeasingPropertyWebApiHandler_getWebAnalytics_Path, getParams] as const;

export const LeasingPropertyWebApiHandler_getWebAnalytics_queryOptions = (
  getParams: GetWebAnalyticsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyWebApiHandler_getWebAnalytics_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getWebAnalytics(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get listing web analytics data
 */
export const useLeasingPropertyWebApiHandler_getWebAnalytics = (
  getParams: GetWebAnalyticsParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getWebAnalytics_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingPropertyWebApiHandler_getWebAnalytics_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyWebApiHandler_getWebAnalytics.getKey = LeasingPropertyWebApiHandler_getWebAnalytics_GetKey;
